import React, { FC } from 'react'
import { renderRichText } from '../../../../utils/richTextHandler.utils'

//* styles
import { RichTextWrapper } from '../../../../styles/global'
import { BioShortDescription } from '../style'

//* components
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  cn: any
  bio: any
  href: string
}

export const Description: FC<Props> = ({ cn, bio, href }) => (
  <BioShortDescription {...cn} data-cy="bioShortDescription">
    {bio.headshot.url && (
      <WrapperImage
        src={bio.headshot.url}
        alt={bio.headshot.alt}
        width={80}
        height={80}
        threshold={650}
      />
    )}

    <div>
      {bio.firstName && bio.lastName && (
        <a href={href}>
          {bio.firstName} {bio.lastName}
        </a>
      )}

      {bio.role && bio.company ? (
        <Typography type="body" className="BioHero__Short-Description font__inter">
          {bio.role}, {bio.company}
        </Typography>
      ) : (
        bio.miniBio && (
          <RichTextWrapper $type="body" className="BioHero__Short-Description font__inter">
            {renderRichText(bio.miniBio)}
          </RichTextWrapper>
        )
      )}
    </div>
  </BioShortDescription>
)
